import { Hosts } from '../../constants/hostName';

export interface IPathnameInitialStateProps {
  color: string;
  host: string;
  siteNumber: number;
  pathname: string | null
}

export const pathnameInitialState:IPathnameInitialStateProps = {
  color: '#ce0e2d',
  host: 'bevnet.com',
  // Default to CPG Media (the bare-route brand) so the first render before
  // SiteAddress dispatches setSettings already matches the resolved bare value.
  siteNumber: Hosts.CPGJOBS,
  pathname: null
};
